import React, { useEffect, useState } from "react";
import Fade from "react-reveal/Fade";
import { Row, Col } from "react-bootstrap";
import axios from "axios";


const urlAdvert =
  "https://www.hubsquares.com/php_files/fetchAdvert.php/";
function CaptionSection({ home }) {
  const [advert, setAdvertHome] = useState([]);
  const [advertInner, setAdvertInner] = useState([]);

  useEffect(() => {
    const fetchListing = () => {
      axios.get(urlAdvert).then((res) => {
        let list = res.data.adverts;
        if(list){
        setAdvertHome(list.filter((l) => l.location === "Home Page"));
        setAdvertInner(list.filter((l) => l.location === "Listings Page"));
        }
      });
    };
    fetchListing();
  }, []);
  return (
    <div>
      {home ? (
        <Row className="text-center">
          <Col md={4}>
            <Fade left>
              <div className="capture my-5">
                {advert.length >= 1 && (
                  advert[0].link ?
                 <a target="_blank" rel="noopener noreferrer" href={advert[0].link}>
                   <img
                    src={`https://www.hubsquares.com/php_files/adverts/${advert[0].image}`}
                    height="200px"
                    width="300px"
                    alt={advert[0].title}
                  />
                 </a>
                  :
                  <img
                    src={`https://www.hubsquares.com/php_files/adverts/${advert[0].image}`}
                    height="200px"
                    width="300px"
                    alt={advert[0].title}
                  />
                )}
              </div>
            </Fade>
          </Col>
          <Col md={4}>
            <Fade top>
              <div className="capture my-5">
                {advert.length >= 2 && (
                  advert[1].link ?
                  <a target="_blank" rel="noopener noreferrer" href={advert[1].link}>
                    <img
                     src={`https://www.hubsquares.com/php_files/adverts/${advert[1].image}`}
                     height="200px"
                     width="300px"
                     alt={advert[1].title}
                   />
                  </a>:
                  <img
                    src={`https://www.hubsquares.com/php_files/adverts/${advert[1].image}`}
                    height="200px"
                    width="90%"
                    alt={advert[1].title}
                  />
                )}
              </div>
            </Fade>
          </Col>
          <Col md={4}>
            <Fade bottom>
              <div className="capture my-5">
                {advert.length >= 3 && (
                  advert[2].link ?
                  <a target="_blank" rel="noopener noreferrer" href={advert[2].link}>
                    <img
                     src={`https://www.hubsquares.com/php_files/adverts/${advert[2].image}`}
                     height="200px"
                     width="300px"
                     alt={advert[2].title}
                   />
                  </a>:
                  <img
                    src={`https://www.hubsquares.com/php_files/adverts/${advert[2].image}`}
                    height="200px"
                    width="300px"
                    alt={advert[2].title}
                  />
                )}
              </div>
            </Fade>
          </Col>
        </Row>
      ) : (
        <div className="capture w-100 my-5">
          {advertInner.length >= 1 && (
            advertInner[0].link ?
            <a target="_blank" rel="noopener noreferrer" href={advertInner[0].link}>
              <img
               src={`https://www.hubsquares.com/php_files/adverts/${advertInner[0].image}`}
               height="200px"
               width="300px"
               alt={advertInner[0].title}
             />
            </a>:
            <img
              src={`https://www.hubsquares.com/php_files/adverts/${advertInner[0].image}`}
              height="300px"
              width="100%"
              alt={advertInner[0].title}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default CaptionSection;
